import React from 'react';
import { Wallet, CreditCard, Receipt, TrendingUp, ArrowUpRight, ArrowDownRight } from 'lucide-react';
const Overview = () => {
  // Dummy data for demonstration
  const wallets = [{
    id: 1,
    currency: 'USD',
    balance: 2540.5,
    code: 'USD'
  }, {
    id: 2,
    currency: 'GBP',
    balance: 1250.75,
    code: 'GBP'
  }, {
    id: 3,
    currency: 'NGN',
    balance: 450000.0,
    code: 'NGN'
  }, {
    id: 4,
    currency: 'ZAR',
    balance: 18500.25,
    code: 'ZAR'
  }, {
    id: 5,
    currency: 'GHS',
    balance: 7800.0,
    code: 'GHS'
  }];
  const recentTransactions = [{
    id: 1,
    type: 'credit',
    description: 'Wallet Funding',
    amount: 500,
    currency: 'USD',
    date: '2023-06-15',
    status: 'completed'
  }, {
    id: 2,
    type: 'debit',
    description: 'Netflix Subscription',
    amount: 15.99,
    currency: 'USD',
    date: '2023-06-14',
    status: 'completed'
  }, {
    id: 3,
    type: 'debit',
    description: 'Airtime Recharge',
    amount: 10,
    currency: 'USD',
    date: '2023-06-12',
    status: 'completed'
  }, {
    id: 4,
    type: 'credit',
    description: 'Refund',
    amount: 25.5,
    currency: 'USD',
    date: '2023-06-10',
    status: 'completed'
  }, {
    id: 5,
    type: 'debit',
    description: 'DSTV Subscription',
    amount: 45,
    currency: 'USD',
    date: '2023-06-08',
    status: 'completed'
  }];
  const getCurrencySymbol = (code: string) => {
    const symbols: {
      [key: string]: string;
    } = {
      USD: '$',
      GBP: '£',
      NGN: '₦',
      ZAR: 'R',
      GHS: '₵'
    };
    return symbols[code] || code;
  };
  return <div className="py-6" data-id="element-450">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8" data-id="element-451">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-452">
          Dashboard Overview
        </h1>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8" data-id="element-453">
        {/* Balance Summary */}
        <div className="mt-6" data-id="element-454">
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-455">
            {/* Total Balance */}
            <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-456">
              <div className="p-5" data-id="element-457">
                <div className="flex items-center" data-id="element-458">
                  <div className="flex-shrink-0" data-id="element-459">
                    <Wallet className="h-6 w-6 text-gray-400" data-id="element-460" />
                  </div>
                  <div className="ml-5 w-0 flex-1" data-id="element-461">
                    <dl data-id="element-462">
                      <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-463">
                        Total Balance (USD)
                      </dt>
                      <dd data-id="element-464">
                        <div className="text-lg font-medium text-gray-900" data-id="element-465">
                          $3,250.75
                        </div>
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-5 py-3" data-id="element-466">
                <div className="text-sm" data-id="element-467">
                  <a href="#" className="font-medium text-blue-700 hover:text-blue-900" data-id="element-468">
                    View all wallets
                  </a>
                </div>
              </div>
            </div>
            {/* Virtual Cards */}
            <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-469">
              <div className="p-5" data-id="element-470">
                <div className="flex items-center" data-id="element-471">
                  <div className="flex-shrink-0" data-id="element-472">
                    <CreditCard className="h-6 w-6 text-gray-400" data-id="element-473" />
                  </div>
                  <div className="ml-5 w-0 flex-1" data-id="element-474">
                    <dl data-id="element-475">
                      <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-476">
                        Active Virtual Cards
                      </dt>
                      <dd data-id="element-477">
                        <div className="text-lg font-medium text-gray-900" data-id="element-478">
                          2
                        </div>
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-5 py-3" data-id="element-479">
                <div className="text-sm" data-id="element-480">
                  <a href="#" className="font-medium text-blue-700 hover:text-blue-900" data-id="element-481">
                    Manage cards
                  </a>
                </div>
              </div>
            </div>
            {/* Bill Payments */}
            <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-482">
              <div className="p-5" data-id="element-483">
                <div className="flex items-center" data-id="element-484">
                  <div className="flex-shrink-0" data-id="element-485">
                    <Receipt className="h-6 w-6 text-gray-400" data-id="element-486" />
                  </div>
                  <div className="ml-5 w-0 flex-1" data-id="element-487">
                    <dl data-id="element-488">
                      <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-489">
                        Recent Bill Payments
                      </dt>
                      <dd data-id="element-490">
                        <div className="text-lg font-medium text-gray-900" data-id="element-491">
                          12
                        </div>
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-5 py-3" data-id="element-492">
                <div className="text-sm" data-id="element-493">
                  <a href="#" className="font-medium text-blue-700 hover:text-blue-900" data-id="element-494">
                    Pay bills
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Wallets */}
        <div className="mt-8" data-id="element-495">
          <h2 className="text-lg leading-6 font-medium text-gray-900" data-id="element-496">
            My Wallets
          </h2>
          <div className="mt-4 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-497">
            {wallets.map(wallet => <div key={wallet.id} className="bg-white overflow-hidden shadow rounded-lg" data-id="element-498">
                <div className="p-5" data-id="element-499">
                  <div className="flex items-center" data-id="element-500">
                    <div className="flex-shrink-0" data-id="element-501">
                      <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold" data-id="element-502">
                        {wallet.currency}
                      </div>
                    </div>
                    <div className="ml-5 w-0 flex-1" data-id="element-503">
                      <dl data-id="element-504">
                        <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-505">
                          {wallet.currency} Wallet
                        </dt>
                        <dd data-id="element-506">
                          <div className="text-lg font-medium text-gray-900" data-id="element-507">
                            {getCurrencySymbol(wallet.code)}{' '}
                            {wallet.balance.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                          </div>
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-5 py-3 flex justify-between" data-id="element-508">
                  <div className="text-sm" data-id="element-509">
                    <a href="#" className="font-medium text-blue-700 hover:text-blue-900" data-id="element-510">
                      Fund
                    </a>
                  </div>
                  <div className="text-sm" data-id="element-511">
                    <a href="#" className="font-medium text-blue-700 hover:text-blue-900" data-id="element-512">
                      Withdraw
                    </a>
                  </div>
                  <div className="text-sm" data-id="element-513">
                    <a href="#" className="font-medium text-blue-700 hover:text-blue-900" data-id="element-514">
                      Convert
                    </a>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
        {/* Recent Transactions */}
        <div className="mt-8" data-id="element-515">
          <h2 className="text-lg leading-6 font-medium text-gray-900" data-id="element-516">
            Recent Transactions
          </h2>
          <div className="mt-4 flex flex-col" data-id="element-517">
            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" data-id="element-518">
              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" data-id="element-519">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" data-id="element-520">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-521">
                    <thead className="bg-gray-50" data-id="element-522">
                      <tr data-id="element-523">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-524">
                          Transaction
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-525">
                          Date
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-526">
                          Amount
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-527">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-528">
                      {recentTransactions.map(transaction => <tr key={transaction.id} data-id="element-529">
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-530">
                            <div className="flex items-center" data-id="element-531">
                              <div className={`flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center ${transaction.type === 'credit' ? 'bg-green-100' : 'bg-red-100'}`} data-id="element-532">
                                {transaction.type === 'credit' ? <ArrowUpRight className={`h-4 w-4 ${transaction.type === 'credit' ? 'text-green-600' : 'text-red-600'}`} data-id="element-533" /> : <ArrowDownRight className={`h-4 w-4 ${transaction.type === 'credit' ? 'text-green-600' : 'text-red-600'}`} data-id="element-534" />}
                              </div>
                              <div className="ml-4" data-id="element-535">
                                <div className="text-sm font-medium text-gray-900" data-id="element-536">
                                  {transaction.description}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-537">
                            <div className="text-sm text-gray-900" data-id="element-538">
                              {transaction.date}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-539">
                            <div className={`text-sm font-medium ${transaction.type === 'credit' ? 'text-green-600' : 'text-red-600'}`} data-id="element-540">
                              {transaction.type === 'credit' ? '+' : '-'}{' '}
                              {getCurrencySymbol(transaction.currency)}
                              {transaction.amount.toFixed(2)}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-541">
                            <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-542">
                              {transaction.status}
                            </span>
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 text-sm" data-id="element-543">
            <a href="#" className="font-medium text-blue-700 hover:text-blue-900" data-id="element-544">
              View all transactions
            </a>
          </div>
        </div>
      </div>
    </div>;
};
export default Overview;